<iatec-suporte-ai
    *ngIf="canRender"
    [attr.token]="contextData!.token"
    [attr.user]="contextData!.user"
    [attr.email]="contextData!.email"
    [attr.system]="contextData!.system"
    [attr.entity]="contextData!.entity"
    [attr.area]="contextData!.area"
    [attr.role]="contextData!.role"
    [attr.language]="contextData!.language"
    [attr.position]="'bottom-right'">
</iatec-suporte-ai>
